module.exports = __webpack_public_path__ + "img/dota.c078bd3c.png";